import React from "react";
import { Link } from "react-router-dom";

const base =
  "inline-flex items-center justify-center gap-2 font-medium rounded-xl transition-colors transition-shadow duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-60 disabled:pointer-events-none select-none";

const variants = {
  primary:
    "bg-navy text-white hover:bg-[#0B254B] shadow-[0_10px_30px_rgba(8,28,58,0.18)] hover:shadow-[0_16px_44px_rgba(8,28,58,0.26)] focus-visible:ring-[color:var(--ssa-focus)] focus-visible:ring-offset-white",
  light:
    "bg-white text-navy hover:bg-white/90 shadow-[0_10px_30px_rgba(8,28,58,0.18)] focus-visible:ring-[color:var(--ssa-focus)] focus-visible:ring-offset-transparent",
  outline:
    "border border-[color:var(--ssa-border-strong)] text-navy bg-white/60 backdrop-blur hover:bg-white focus-visible:ring-[color:var(--ssa-focus)] focus-visible:ring-offset-white",
  outlineLight:
    "border border-white/40 text-white bg-white/5 backdrop-blur hover:bg-white/12 focus-visible:ring-white/60 focus-visible:ring-offset-transparent",
  gold:
    "border border-[color:var(--ssa-gold)] text-gold bg-transparent hover:bg-[rgba(184,155,94,0.1)] focus-visible:ring-[color:var(--ssa-gold)] focus-visible:ring-offset-transparent",
  ghost:
    "text-navy hover:bg-[rgba(8,28,58,0.06)] focus-visible:ring-[color:var(--ssa-focus)] focus-visible:ring-offset-white",
};

const sizes = {
  md: "h-11 px-5 text-sm",
  lg: "h-12 px-6 text-sm",
  xl: "h-14 px-7 text-base",
};

export const Button = ({
  as = "button",
  to,
  href,
  variant = "primary",
  size = "lg",
  className = "",
  children,
  ...props
}) => {
  const cls = `${base} ${variants[variant] || variants.primary} ${sizes[size] || sizes.lg} ${className}`;
  if (to) {
    return (
      <Link to={to} className={cls} {...props}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} {...props}>
        {children}
      </a>
    );
  }
  const Comp = as;
  return (
    <Comp className={cls} {...props}>
      {children}
    </Comp>
  );
};
